<ng-template #copyIdBtn>
    <i
        [ngClass]="{ pi: true, 'pi-copy': !copied, 'pi-spinner': copied, 'pi-spin': copied}"
        [pTooltip]="'common.copyId' | translate"
        (click)="copyId($event)"
    ></i>
</ng-template>

<p-card [ngClass]="{ 'cursor-pointer': !!link }" (click)="goto()">
    <div class="infoBlock">
        <div class="flex-column gap-x-small singleCell" style="z-index: 1;">

            <!-- Donor -->
            @if (item.entity === 'donor') {
                <div class="mb-1 flex gap-2 align-items-center copyBtn">
                    <ng-container [ngTemplateOutlet]="copyIdBtn"></ng-container>
                    <span class="text-500">{{ entityId }}</span>
                </div>
                <div class="mb-1 flex gap-2 align-items-center">
                    <b>{{ item!.data.name }}</b>
                </div>
                @for (it of item.data.emails || []; track $index; let first = $first) {
                    <div>
                        {{ first ? '' : ', ' }}{{ it.email }}
                    </div>
                }
                <div>
                    {{ 'donor.fields.comment' | translate }}: <span>{{ item!.data.comment }}</span>
                </div>
            }
            <!-- /Donor -->

            <!-- Donation -->
            @if (item.entity === 'donation') {
                <div class="flex gap-2 align-items-center copyBtn">
                    <span class="text-500">{{ entityId }}</span>
                    <ng-container [ngTemplateOutlet]="copyIdBtn"></ng-container>
                </div>
                <div class="flex gap-2 align-items-center">
                    <b>{{ 'donation.fields.donorName' | translate }}: {{ item!.data.donorName }}</b>
                </div>
                <div>
                    {{ 'donation.fields.amount' | translate }}: {{ item!.data.amount }}
                </div>
                <div>
                    {{ 'donation.fields.collectionName' | translate }}: {{ item!.data.collectionName }}
                </div>
                <div>
                    {{ 'donation.donationForm.label' | translate }}:
                    @if (item!.data.donationForm) {
                        <span>{{ item!.data.donationForm.name }}</span>
                    }
                </div>
            }
            <!-- /Donation -->

            <!-- Collection -->
            @if (item.entity === 'collection') {
                <div class="flex gap-2 align-items-center copyBtn">
                    <span class="text-500">{{ entityId }}</span>
                    <ng-container [ngTemplateOutlet]="copyIdBtn"></ng-container>
                </div>
                <div class="flex gap-2 align-items-center">
                    <b class="mr-2">{{ 'collection.fields.name' | translate }}: {{ item!.data.name }}</b>
                </div>
                <div>
                    {{ 'collection.fields.comment' | translate }}: {{ item!.data.comment }}
                </div>
                <div>
                    {{ 'collection.fields.active' | translate }}:
                    <app-check-or-cross [value]="item!.data.active"></app-check-or-cross>
                </div>
                <div>
                    {{ 'collection.fields.longTerm' | translate }}:
                    <app-check-or-cross [value]="item!.data.longTerm"></app-check-or-cross>
                </div>
            }
            <!-- /Collection -->

            <!-- Folder -->
            @if (item.entity === 'folder') {
                @if (!withTag) {
                    <div class="flex justify-content-end align-items-start">
                        <app-service-colored-tag [serviceId]="item.data.serviceInfo.id"></app-service-colored-tag>
                    </div>
                }
                <div class="flex gap-2 align-items-center copyBtn">
                    <b class="mr-2">{{ 'folder.fields.name' | translate }}
                        : {{ item!.data.person | formatPerson }}</b>
                </div>
                <div>
                    {{ 'folder.fields.birthDate' | translate }}: {{ item!.data.person.birthdate | shortDate }}
                </div>
                <div>
                    {{ 'folder.fields.address' | translate }}: {{ item!.data.person.addresses | formatAddress }}
                </div>
            }
            <!-- /Folder -->

            <!-- Procedure -->
            @if (item.entity === 'performedProcedure') {
                <div class="flex justify-content-end align-items-start">
                    <app-service-colored-tag [serviceId]="item.data.serviceInfo.id"></app-service-colored-tag>
                </div>
                <div class="flex gap-2 align-items-center copyBtn">
                    <b class="mr-2">{{ 'procedures.performed.fields.code' | translate }}: {{ item!.data.code }}</b>
                </div>
                <div>
                    {{ 'procedures.performed.fields.folder' | translate }}: {{ item!.data.person | formatPerson }}
                </div>
                <div>
                    {{ 'procedures.performed.fields.dateFrom' | translate }}
                    : {{ item!.data.work?.dateFrom | shortDate }}
                </div>
                <div class="flex">
                    <div>{{ 'procedures.performed.fields.user' | translate }}:</div>
                    <div class="flex flex-column">
                        @for (user of item.data.users; track user.id) {
                            <div>
                                {{ user | formatPerson }}
                            </div>
                        }
                    </div>
                </div>
            }
            <!-- /Procedure -->

            <!-- History -->
            @if (item.entity === 'history') {
                <div class="flex gap-2 align-items-center copyBtn">
                    @if (item.data['entityName'] === 'donor') {
                        <b>{{ item!.tree.data.details | formatPerson }}</b>
                    }
                    @if (item.data['entityName'] === 'donation') {
                        <b>{{ item!.tree.data.donorName }}</b>
                    }
                    @if (item.data['entityName'] === 'collection') {
                        <b>{{ item!.tree.data.name }}</b>
                    }
                    <span class="ml-2 text-500">{{ entityId }}</span>
                    <ng-container [ngTemplateOutlet]="copyIdBtn"></ng-container>
                </div>
                <div>
                    <span>{{ 'entities.history.changeFields' | translate }}: </span>
                    @for (leaf of item!.tree.alteredLeaves; track $index; let index = $index) {
                        <span>
                            @if (index > 0) {
                                <span>, </span>
                            }
                            <span>{{ item.data['entityName'] + '.fields.' + leaf | translate }}</span>
                        </span>
                    }
                </div>
                <p-inplace
                    #historyTree
                    (onActivate)="stopPropagation($event)"
                    (onDeactivate)="stopPropagation($event)"
                >
                    <ng-template pTemplate="display">
                        <app-link-button label="entities.history.showChanges"></app-link-button>
                    </ng-template>
                    <ng-template pTemplate="content">
                        <app-audit-log-tree
                            (click)="stopPropagation($event)"
                            [tree]="item.tree.tree"
                            [entityName]="item.data.entityName"
                        ></app-audit-log-tree>
                        <div class="flex justify-content-end">
                            <app-link-button label="entities.history.hideChanges"
                                (clickEvent)="hideHistoryTree($event)"></app-link-button>
                        </div>
                    </ng-template>
                </p-inplace>
                <div>
                    {{ 'entities.history.fields.comment' | translate }}: {{ item!.data.comment }}
                </div>
                <div>
                    {{ 'entities.history.fields.authorName' | translate }}: {{ item!.data.authorName }}
                </div>
            }
            <!-- /History -->
        </div>

        @if (withTag) {
            <div class="flex justify-content-end align-items-start relative singleCell">
                <div class="flex gap-small align-items-end">
                    <p-tag [severity]="severity" [value]="'entities.' + tagLabel | translate"></p-tag>
                    @if (item?.data?.serviceInfo?.id) {
                        <app-service-colored-tag [serviceId]="item.data.serviceInfo.id"></app-service-colored-tag>
                    }
                </div>
            </div>
        }

        <div class="flex gap-small justify-content-end align-items-end relative mt-2">
            @if (dateLabel.length) {
                <div>{{ dateLabel | translate }}:</div>
            }
            <div>{{ item.date | localDate }}</div>
        </div>
    </div>
</p-card>
